import React, { useEffect, useState } from "react";
import "./ListSelector.css";

import RadioListActive from "../../assets/radial-filter-button-ON.svg";
import { useSelector } from "react-redux";

const ListSelector = ({ restaurantData, setSelectedLocations }) => {
  const [selectedRestaurantId, setSelectedRestaurantId] = useState();

  const state = useSelector((state) => state.deliciousFilterType);

  const [showList, setShowList] = useState(restaurantData);

  useEffect(() => {
    // Filtering the content shown based on Filters
    const selectedCusinies = state.selectedCuisineFilters;
    const selectedRegions = state.selectedRegionFilters;

    const filteredList = restaurantData?.filter((dataObj) => {
      const matchCuisine =
        selectedCusinies?.includes(dataObj.cuisine) ||
        selectedCusinies?.includes("All");

      const matchRegion = Array.isArray(dataObj.region)
        ? dataObj.region.some(
            (region) =>
              selectedRegions?.includes(region) ||
              selectedRegions?.includes("All")
          )
        : selectedRegions?.includes(dataObj.region) ||
          selectedRegions?.includes("All");

      return matchCuisine && matchRegion;
    });

    // console.log("filteredList", filteredList);

    setShowList(filteredList);
  }, [state, restaurantData]);

  const handleRestaurantSelection = (restaurant) => {
    setSelectedRestaurantId(restaurant?.id);
    setSelectedLocations(
      restaurantData.find(
        (restaurantObj) => restaurantObj.id === restaurant?.id
      )
    );
  };

  return (
    <div className="delicious100-interactive__list_selector">
      <div className="delicious100-interactive__list_selector_header1">
        <span>Click on restaurant to locate on map</span>
      </div>
      <div className="delicious100-interactive__list_selector_header2">
        <img
          className="delicious100-interactive__list_selector_header2_img"
          src={RadioListActive}
          alt="RadioListActive"
        ></img>
        <span>Restaurants near me</span>
      </div>
      <div className="delicious100-interactive__list_selector_list">
        {showList?.map((restaurant) => {
          return (
            <div
              className={
                selectedRestaurantId === restaurant?.id
                  ? "delicious100-interactive__list_selector_list_item_active"
                  : "delicious100-interactive__list_selector_list_item"
              }
              key={restaurant["restaurant-name"]}
              onClick={() => handleRestaurantSelection(restaurant)}
            >
              <span key={restaurant["restaurant-name"]}>
                {restaurant["restaurant-name"]}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ListSelector;
